module.exports = __webpack_public_path__ + "img/outlook.afc7b213.png";